module.exports = __webpack_public_path__ + "static/media/top-underlay.b9b14509.png";